export default __webpack_public_path__ + "static/media/beagle_swap.77af67c9.jpeg";